"use client";
import React, { useRef } from "react";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import DesktopHeader from "./desktop/DesktopHeader";
import MobileHeader from "./mobile/MobileHeader";

gsap.registerPlugin(ScrollTrigger);

const Header = () => {
  const progressRef = useRef(null);

  useGSAP(() => {
    gsap.to(progressRef.current, {
      width: "100%",
      ease: "none",
      scrollTrigger: {
        trigger: "body",
        start: "top top",
        end: "bottom bottom",
        scrub: true,
      },
    });
  }, []);

  return (
    <>
      <div className="hidden xl:block">
        <DesktopHeader />
      </div>
      <div className="xl:hidden">
        <MobileHeader />
      </div>

      <div
        ref={progressRef}
        className="h-1 bg-red-700 fixed top-0 left-0 z-50 w-0"
      ></div>
    </>
  );
};

export default Header;
